/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT : STYLES --------------- ++++++++++ */
export default theme => ({
    account: {
        // animate in copy and details on load
        '& .name-page-copy': {
        	opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '& .name-page-details': {
        	opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.175s',
        },

        // when tables have buttons inside them
        '& .editcolumn': {
            textAlign: 'right',
            whiteSpace: 'nowrap',
            '& .link': {
                margin: replacePXinStringWithEM(`0 7px`)
            }
        }
    }
});
